export default "71618:393:P, 71916:1154:P, CONFIG.4084862, CONFIG.4725167, CONFIG.3960925\n";